import { render, staticRenderFns } from "./DashboardHub.vue?vue&type=template&id=4a7d40a3&"
import script from "./DashboardHub.vue?vue&type=script&lang=js&"
export * from "./DashboardHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports